<template>

  <portlet
      :icon="'far fa-chart-bar portlet-icon'"
      :title="$t('menu.reporting')"
      :actions-block="true"
      :fullheight="true"
      class="portlet  "
  >
    <template slot="actionsBlock">
      <div class="row" style="width:800px;">
        <div class="col-2 mr-auto">
<!--          <button  class="btn btn-print" @click="">Print</button>-->

          <Button
                  :color="getColors.defaultColorSolidButton" :outline="false"
                  :disabled="false"
                  @frameworkButtonClicked="print()"
                  :backgroundColor="getColors.defaultBackgroundColorSolidButton" :size="'extra-small'">
            <template #button-content><span>{{ $t('print') }}</span><i class="fas fa-print"></i></template>
          </Button>
        </div>
        <div class="col-10">
          <select class="form-control report-selector" name="selectedReport" v-model="selectedReport">
            <option :value="null" selected disabled>{{ $t('ui.select') }}</option>
            <option v-for="report in availableReports" :key="report.id" :value="report">
              {{ report.name }}
            </option>
          </select>
        </div>
      </div>
    </template>

    <template slot="portletBody">

      <PowerBiEmbed class="pbi-embed" :config="config"/>

    </template>
  </portlet>

</template>

<script>
import PowerBiEmbed from "@/components/reporting/PowerBiEmbed";
import axios from "axios";
import {mapGetters} from "vuex";
import * as pbi from "powerbi-client";
import Button from "@/components/ui/Button.vue";
import colors from "@/assets/scss/MotivateColors.scss";
export default {
  name: "Reporting",
  components: {Button, PowerBiEmbed},
  data() {
    return {
      fullScreen: false,
      selectedReport: null,
      availableReports: null,
      config: null,
    };
  },
  computed: {
    getColors(){
      return colors
    },
    ...mapGetters("users", ["getClaims"]),
    ...mapGetters("powerBiEmbed", ["getReports"]),
  },
  methods: {
    print() {
      let powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
      );
      var element = $('#powerBIcontainer')[0];
      var report = powerbi.get(element);

      report.print();

    },
    async getAvailableReports() {
      this.$store.commit("setLoading", true);
      try {
        let companyId = this.getClaims.companyId;
        let reports = (await this.$FB.collection("powerBiEmbed").doc(companyId).get()).data();
        this.availableReports = reports.reports;
      } catch (e) {
        console.log(e);
      }
      if (this.availableReports.length == 1) {
        this.selectedReport = this.availableReports[0]
      }
      this.$store.commit("setLoading", false);
    },
    async getReportSettings(report) {
      this.$store.commit("setLoading", true);
      let baseUrl = process.env.VUE_APP_CLOUD_HTTP_API
      let response = await axios.post(
          baseUrl + '/authentication/authenticate/powerbi',
          // "http://127.0.0.1:5001/performance-management-tool/europe-west1/http_http/authentication/authenticate/powerbi",
          {
            uid: this.getClaims.user_id,
            reportId: report.ReportId,
            workspaceId: report.WorkspaceId,
          }
      );

      this.config = response.data;
      this.$store.commit("setLoading", false);
    },
  },
  watch: {

    selectedReport(newV) {
      if (newV) {
        this.getReportSettings(newV);
      }
    },
  },
  mounted() {
    this.getAvailableReports();
  },
};
</script>


<style scoped lang="scss">
@import "@/assets/scss/MotivateColors.scss";
.report-selector{
  color:$besWelBlack;
  font-size:20px;
  border-color:$besWelBlack;
  border-radius:4px;
}
.full-height-container {
  height: 90vh; /* Full screen height */
  display: flex;
  flex-direction: column;
}

::v-deep  .m-portlet__body {
  height: 80vh;
  padding: 0;
}


.pbi-embed {
  flex: 1;
  width: 100%;
  height: 100%;
}
</style>
